import React from 'react';
import { Moon, Sun } from 'lucide-react';
import { useBranding } from '@/lib/BrandingContext';

export default function DarkModeToggle() {
  const { colorScheme, changeColorScheme, disabled } = useBranding();
  const dark = colorScheme === 'dark';
  return <button type="button" className="color-scheme-toggle" aria-label="Dark mode" aria-pressed={dark} title={dark ? 'Switch to light mode' : 'Switch to dark mode'} disabled={disabled} onClick={() => changeColorScheme(dark ? 'light' : 'dark')}>
    {dark ? <Sun size={18} /> : <Moon size={18} />}
  </button>;
}
